import i18n from '~/locales/i18n'

const RecurrenceType = {
  ONCE: i18n.t('Time:LABEL.REPEAT_ONCE'),
  WEEKLY: i18n.t('Time:LABEL.WEEKLY'),
}

export default RecurrenceType
